import React from "react";
import { getFullName } from "../../../careprovider/visits/utils";
import { Table, Tooltip } from "antd";
import moment from "moment";
import { getLocalTimeZoneDateFormat } from "../../../../utils/dateutils";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useNavigate } from "react-router-dom";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";

const VolunteerActivityTable = ({ carePlanData, volunteerId }) => {
  const role = useGetRole();
  const navigate = useNavigate();

  const getFlatTaskDetails = (data) => {
    const flatArray = [];
    const opportunities = data?.opportunities ?? [];
    const filteredOpportunity = opportunities.filter(
      (opportunity) => opportunity.workforce?.userIdentifier === volunteerId
    );

    const allOpportunities = volunteerId
      ? filteredOpportunity
      : opportunities;

    allOpportunities?.forEach((opportunity) => {
      opportunity?.tasks?.forEach((task) => {
        const form = JSON.parse(task?.formIdentifier || "[]");
        flatArray.push({
          taskDate: task?.taskDate,
          status: task?.status,
          taskId: task?.id,
          workforce: opportunity?.workforce,
          form: form[0],
          opportunityId: opportunity?.id,
        });
      });
    });

    return flatArray.reverse();
  };
  const volunteerActivity = getFlatTaskDetails(carePlanData, volunteerId);

  const handleFormView = async (record) => {
    navigate(
      `${RoleToLinkMapper(role)}form-viewer?templateCode=${
        record?.form?.templateCode
      }&patientIdentifier=${
        carePlanData?.patient?.userIdentifier
      }&workforceIdentifier=${
        record?.workforce?.userIdentifier
      }&formIdentifier=${
        record?.form?.formIdentifier
      }&readOnly=${true}&opportunityId=${record?.opportunityId}&taskId=${
        record?.taskId
      }`
    );
  };

  const columns = [
    {
      title: "Date",
      key: "date",
      render: (_, { taskDate }) =>
        taskDate ? moment(taskDate).format(getLocalTimeZoneDateFormat()) : "--",
    },
    !volunteerId && {
      title: "Volunteer",
      key: "volunteer",
      render: (_, { workforce }) =>
        getFullName(workforce.givenName, workforce.familyName),
    },
    {
      title: "Form",
      key: "form",
      render: (_, { form }) => form?.formName,
    },
    {
      title: "Status",
      key: "status",
      render: (_, { status }) => status === "Submitted" ? "Pending Approval" : status,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Tooltip title="View Form" placement="bottom">
          <SmartIcon
            iconKey={"report"}
            handleIconClick={() => handleFormView(record)}
          />
        </Tooltip>
      ),
    },
  ].filter(Boolean);

  return (
    <>
      {volunteerActivity?.length > 0 && (
        <>
          <span>Volunteer Activity</span>
          <Table
            className="tableStyling"
            columns={columns}
            dataSource={volunteerActivity}
            pagination={false}
          />
        </>
      )}
    </>
  );
};

export default VolunteerActivityTable;
